export default __webpack_public_path__ + "static/media/Girdle of Indomitable Souls.dc04297d.jpg";